(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-enhance"]) return;
  try {
    
  (function () {
    const root = document.querySelector('main[data-template^="collection"]');
    if (!root) return;

    const tpl = root.querySelector('[data-collection-nav-template]');
    if (!tpl) return;

    const build = () => tpl.content.firstElementChild.cloneNode(true);

    const inject = () => {
      // desktop: top of the vertical filter sidebar, above the filters
      const sidebar = root.querySelector('.facets--vertical .facets__form');
      if (sidebar && !sidebar.querySelector('.bs-colnav')) {
        sidebar.insertBefore(build(), sidebar.firstChild);
      }

      // mobile: top of the filter drawer
      const drawer = document.querySelector('.facets-drawer__filters');
      if (drawer && !drawer.querySelector('.bs-colnav')) {
        drawer.insertBefore(build(), drawer.firstChild);
      }
    };

    inject();

    // The theme re-renders the results list when filters or sorting change,
    // which removes the injected nav. Put it back when that happens.
    const list = root.querySelector('results-list');
    if (list && 'MutationObserver' in window) {
      let queued = false;
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          inject();
        });
      }).observe(list, { childList: true, subtree: true });
    }

    // ---- scroll reveal, scoped to this template ----
    (function reveal() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;

      const pending = new Set();

      const mark = () => {
        const groups = [
          [root.querySelectorAll('.bs-colnav, .facets__item'), 60],
          [root.querySelectorAll('.product-grid__item'), 45],
        ];
        groups.forEach(([nodes, step]) => {
          let i = 0;
          nodes.forEach((el) => {
            if (el.hasAttribute('data-r')) return;
            el.setAttribute('data-r', '');
            el.style.setProperty('--d', Math.min(i * step, 320) + 'ms');
            pending.add(el);
            i++;
          });
        });
      };

      const show = (el) => {
        el.classList.add('is-in');
        pending.delete(el);
      };

      const inView = (el) => {
        const b = el.getBoundingClientRect();
        if (!b.height && !b.width) return true;
        return b.top < window.innerHeight * 0.95 && b.bottom > 0;
      };

      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (!e.isIntersecting) return;
            show(e.target);
            io.unobserve(e.target);
          });
        },
        { threshold: 0.05, rootMargin: '0px 0px -4% 0px' }
      );

      const scan = () => {
        mark();
        pending.forEach((el) => (inView(el) ? show(el) : io.observe(el)));
      };

      root.setAttribute('data-bs-reveal', 'on');
      scan();

      let queued = false;
      const sweep = () => {
        queued = false;
        pending.forEach((el) => inView(el) && show(el));
      };
      window.addEventListener(
        'scroll',
        () => {
          if (queued) return;
          queued = true;
          requestAnimationFrame(sweep);
        },
        { passive: true }
      );
      window.addEventListener('load', sweep);
      setTimeout(sweep, 800);

      // new cards arrive after filtering or pagination
      const list = root.querySelector('results-list');
      if (list) {
        let q = false;
        new MutationObserver(() => {
          if (q) return;
          q = true;
          requestAnimationFrame(() => {
            q = false;
            scan();
            sweep();
          });
        }).observe(list, { childList: true, subtree: true });
      }

      // never leave anything hidden
      setTimeout(() => pending.forEach(show), 8000);
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-intro"]) return;
  try {
    
  (function () {
    const intro = document.querySelector('[data-bs-intro]');
    if (!intro) return;

    let finished = false;

    const dismiss = () => {
      if (finished) return;
      finished = true;
      intro.classList.add('is-done');
      // remove from the DOM so it can never block interaction
      setTimeout(() => {
        if (intro.parentNode) intro.parentNode.removeChild(intro);
      }, 750);
    };

    // keep it on screen briefly so it reads as intentional, not a flash
    const MIN = 700;
    const started = performance.now();
    const finishWhenReady = () => {
      const waited = performance.now() - started;
      setTimeout(dismiss, Math.max(0, MIN - waited));
    };

    if (document.readyState === 'complete') {
      finishWhenReady();
    } else {
      window.addEventListener('load', finishWhenReady, { once: true });
    }

    // failsafe: never let the overlay stick, whatever happens
    setTimeout(dismiss, 4000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-motion"]) return;
  try {
    
  (function () {
    const root = document.querySelector('main[data-template^="index"]');
    if (!root) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const all = (sel, ctx) => Array.from((ctx || root).querySelectorAll(sel));
    const sec = (id) => root.querySelector('#shopify-section-' + id);

    const mark = (nodes, type, step, base) => {
      let i = 0;
      (nodes || []).forEach((el) => {
        if (!el || el.hasAttribute('data-anim')) return;
        el.setAttribute('data-anim', type);
        el.style.setProperty('--d', (base || 0) + i * (step || 0) + 'ms');
        i++;
      });
    };

    // ---- ticker
    const ticker = sec('ticker_1');
    if (ticker) mark([ticker.firstElementChild || ticker], 'fade');

    // ---- performance metrics
    mark(all('.brothers-counter'), 'up', 140);

    // ---- editorial category grids (tiles already clip their own overflow)
    all('.bs-cat__head').forEach((h) => mark([h], 'up'));
    ['categories_1', 'discovery_1'].forEach((id) => {
      const s = sec(id);
      if (s) mark(all('.bs-cat__tile', s), 'wipe', 160, 160);
    });

    // ---- dark showcase
    // The hero PRODUCT LINK is never animated as a whole. Only its media
    // frame wipes and its caption rises, so the link and its text always
    // remain present and clickable.
    mark(all('.bs-show__headline-wrap'), 'rise');
    mark(all('.bs-show__aside'), 'up', 0, 220);
    mark(all('.bs-show__piece--hero .bs-show__media'), 'wipe', 0, 180);
    mark(all('.bs-show__piece--hero .bs-show__caption'), 'up', 0, 340);
    mark(all('.bs-show__rail .bs-show__piece'), 'slide', 150, 260);

    // ---- product comparison
    const cmp = sec('comparison_section_1');
    if (cmp) {
      const copy = cmp.querySelector('[class*="group"]');
      if (copy) mark(Array.from(copy.children), 'up', 140);
      mark(all('comparison-slider-component', cmp), 'up', 0, 200);
    }

    // ---- brand story
    const story = sec('gear_section_1');
    if (story) {
      const copy = story.querySelector('[class*="group"]');
      if (copy) mark(Array.from(copy.children), 'up', 140, 200);
    }

    // ---- statement break
    mark(all('.bs-statement__rule'), 'slide');
    mark(all('.bs-statement__lines span'), 'rise', 170, 120);
    mark(all('.bs-statement__support'), 'up', 0, 620);

    // ---- delivery + support
    mark(all('.bs-trust__lead'), 'up');
    mark(all('.bs-trust__item'), 'slide', 150, 180);

    const targets = all('[data-anim]');
    if (!targets.length) return;

    const show = (el) => el.classList.add('is-inview');
    const pending = new Set(targets);

    const revealAll = () => {
      pending.forEach(show);
      pending.clear();
    };

    if (!('IntersectionObserver' in window)) {
      return; // never set data-motion, so nothing was ever hidden
    }

    root.setAttribute('data-motion', 'on');

    const inView = (el) => {
      const b = el.getBoundingClientRect();
      if (b.width === 0 && b.height === 0) return true; // nothing to animate
      return b.top < window.innerHeight * 0.94 && b.bottom > 0;
    };

    // Fallback sweep: anything visible but still hidden gets revealed.
    // Covers observer misses, elements taller than the viewport, and
    // anything laid out late (images, fonts).
    let queued = false;
    const sweep = () => {
      queued = false;
      pending.forEach((el) => {
        if (inView(el)) {
          show(el);
          pending.delete(el);
        }
      });
      if (!pending.size) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      }
    };
    const onScroll = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(sweep);
    };

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          show(entry.target);
          pending.delete(entry.target);
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.06, rootMargin: '0px 0px -4% 0px' }
    );

    targets.forEach((el) => {
      if (inView(el)) {
        show(el);
        pending.delete(el);
        return;
      }
      io.observe(el);
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', sweep);
    setTimeout(sweep, 600);
    setTimeout(sweep, 2000);
    // last resort: never leave content hidden
    setTimeout(revealAll, 8000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.bs-ptabs').forEach((wrap) => {
      const tabs = wrap.querySelectorAll('[data-bs-tab]');
      const panels = wrap.querySelectorAll('[data-bs-panel]');

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const name = tab.getAttribute('data-bs-tab');

          tabs.forEach((t) => {
            const on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });

          panels.forEach((p) => {
            p.classList.toggle('is-active', p.getAttribute('data-bs-panel') === name);
          });
        });
      });
    });

    const root = document.querySelector('main[data-template^="product"]');
    if (!root) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    const pending = new Set();

    const add = (nodes, step, base) => {
      let i = 0;
      nodes.forEach((el) => {
        if (!el || el.hasAttribute('data-r')) return;
        el.setAttribute('data-r', '');
        el.style.setProperty('--d', (base || 0) + i * (step || 0) + 'ms');
        pending.add(el);
        i++;
      });
    };

    add(root.querySelectorAll('.bs-ptabs__nav, .bs-ptabs__body'), 90);
    add(root.querySelectorAll('.product-grid__item'), 70, 60);

    if (!pending.size) return;

    const show = (el) => {
      el.classList.add('is-in');
      pending.delete(el);
    };

    const inView = (el) => {
      const b = el.getBoundingClientRect();
      if (!b.height && !b.width) return true;
      return b.top < window.innerHeight * 0.95 && b.bottom > 0;
    };

    root.setAttribute('data-bs-reveal', 'on');

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          show(e.target);
          io.unobserve(e.target);
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px -4% 0px' }
    );

    pending.forEach((el) => {
      if (inView(el)) { show(el); } else { io.observe(el); }
    });

    let queued = false;
    const sweep = () => {
      queued = false;
      pending.forEach((el) => { if (inView(el)) show(el); });
    };

    window.addEventListener('scroll', () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(sweep);
    }, { passive: true });
    window.addEventListener('load', sweep);
    setTimeout(sweep, 800);
    setTimeout(() => pending.forEach(show), 8000);
  })();

  } catch(e) { console.error(e); }
})();
})();
